export default class EmailModel {
  constructor() {
    this.id = null
    this.type = '0'
    this.address = null
    this.isDefault = false
    this.overwriteOnConflict = false
    this.mergeOnConflict = false
    this.isNew = true
  }
}
